const URLS = {
  'Adobe Photoshop': '/static/img/course-detail/photoshop.png',
  'Adobe Illustrator': '/static/img/course-detail/illustrator.png',
  '3D Max': '/static/img/course-detail/3DS-Max.png',
  'After Effects': '/static/img/course-detail/after_effects.png',
  ZBrush: '/static/img/course-detail/zbrush.png',
  Maya: '/static/img/course-detail/maya-new.png',
  'Cinema 4D': '/static/img/course-detail/Cinema4D-new.png',
  Sketch: '/static/img/course-detail/sketch.png',
  Blender: '/static/img/course-detail/Blender.png',
  Sketchup: '/static/img/course-detail/SketchUp.png',
  'Adobe Animate CC': '/static/img/course-detail/animate-cc.png',
  Unity: '/static/img/course-detail/Unity.png',
  UnityWhite: '/static/img/course-detail/UnityWhite.png',
  Nuke: '/static/img/course-detail/nuke.png',
  'Adobe Audition': '/static/img/course-detail/Adobe_Audition.png',
  'Adobe Premiere': '/static/img/course-detail/premiere-cc.png',
  InDesign: '/static/img/course-detail/Adobe_InDesign.png',
  Houdini: '/static/img/course-detail/Houdini-Logo.png',
  Lumion: '/static/img/course-detail/Logo_Lumion.png',
  'Game Maker': '/static/img/course-detail/The_game_maker_logo.png',
  Realflow: '/static/img/course-detail/rflogo.png',
  WordPress: '/static/img/course-detail/wordpress.png',
  'Google Analytics': '/static/img/course-detail/google-analytics.png',
  'Google Ads': '/static/img/course-detail/google-ads.png',
  'Adobe Photoshop Lightroom': '/static/img/course-detail/adobe-lightroom.png',
  Procreate: '/static/img/course-detail/procreate.jpg',
  Git: '/static/img/course-detail/git.png',
  'DaVinci Resolve': '/static/img/course-detail/davinci_software_logo.png',
  ToyRig: '/static/img/course-detail/ToyRig.jpg',
  Rhino3D: '/static/img/course-detail/rhino-3d.png',
  RoughAnimator: '/static/img/course-detail/rough-animator.png',
  Figma: '/static/img/course-detail/figma.png',
  Maze: '/static/img/course-detail/maze.png',
};

const softwareUrl = tag => {
  if (URLS[tag] !== undefined) {
    return URLS[tag];
  }
  return null;
};

export default softwareUrl;
